import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataAnalysisService {
  public timeSeriesSignalChange$: Subject<any> = new Subject();
  public timeSeriesSignalRemove$: Subject<any> = new Subject();
  public timeSeriesSignalAdd$: Subject<any> = new Subject();
  public timeSeriesPeriodChange$: Subject<any> = new Subject();

  public scatterPlotSignalChange$: Subject<any> = new Subject();
  public scatterPlotSignalRemove$: Subject<any> = new Subject();
  public scatterPlotSignalAdd$: Subject<any> = new Subject();
  public scatterPlotPeriodChange$: Subject<any> = new Subject();
}
